import React from 'react'
import classnames from 'classnames'

import { followStoreLink$ } from '../navigation'
import {
  vrpDescriptiveDate,
  hasMerchantName,
} from '@apiEnabler/ob-common/lib/vrp-consents'
import { formatDate } from '@apiEnabler/ob-common/lib/date-utils'

import style from './VrpCard.module.scss'

function DateDisplay({ label, date }) {
  // Non-expiry consent
  if (date === null) {
    return (
      <span className={style.dateBlock}>
        <span className={`${style.dateText} js-date-text`}>{label}</span>
      </span>
    )
  }

  if (date) {
    return (
      <span className={style.dateBlock}>
        <span className={`${style.dateLabel} js-date-label`}>{label}</span>
        <span className={`${style.dateText} js-date-text`}>
          {formatDate(date)}
        </span>
      </span>
    )
  }

  return null
}

export default function VrpCard({ tpp, consent, index }) {
  const { label, date, createdAt } = vrpDescriptiveDate(consent)
  const merchantName = hasMerchantName(consent)
  return (
    <button
      className={classnames(style.card, `js-access-card-${index}`)}
      onClick={() =>
        followStoreLink$.next(
          `/recurring-payments/vrp/tpps/${tpp.get(
            'clientId'
          )}/payments/${consent.get('id')}`
        )
      }
    >
      <div className={`${style.content} js-content`}>
        <span className={`${style.consentName} js-agreement-name`}>
          <span className={classnames(style.accountLabel, 'js-account-label')}>
            {merchantName
              ? `${merchantName}`
              : `${consent.getIn([
                  'payload',
                  'creditor',
                  'account',
                  'customerName',
                ])}`}
          </span>
          <span className={classnames(style.grantedLabel, 'js-granted-label')}>
            {consent.get('status') === 'ACCEPTED'
              ? 'Created on '
              : 'Connected since '}
            <span className={style.accessGrantedDate}>
              {formatDate(createdAt, 'DD MMM YYYY')}
            </span>
          </span>
        </span>
        <DateDisplay label={label} date={date} />
      </div>
    </button>
  )
}
